import { exeRequest } from '../utils/APIUtils'

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    transfertsHistorique: async () => exeRequest(`/admin/transferts/historique`, "GET"),

    sosCreditHistorique: async () => exeRequest(`/admin/sos-credit/historique`, "GET"),

    // nouvelles (avec params)
    transfertsHistoriqueList: async (params) => exeRequest(`/admin/transferts/historique${buildQuery(params)}`, "GET"),
    sosCreditHistoriqueList: async (params) => exeRequest(`/admin/sos-credit/historique${buildQuery(params)}`, "GET"),

    statsSosCredit: async (periode = 'jour') => exeRequest(`/admin/stats-sos-credit/${periode}`, "GET"),

    statsTransferts: async (periode = 'jour') => exeRequest(`/admin/stats-transferts/${periode}`, "GET"),

    deleteHistoriqueSosCreditById: async (id) => exeRequest(`/admin/sos-credit/historique/${id}`, "DELETE"),
    deleteHistoriqueTransfertById: async (id) => exeRequest(`/admin/transferts/historique/${id}`, "DELETE"),

}